// mainly used for setup api end point url, and static content
import { isDevEnv } from './helpers'
import { isStagingEnv } from './helpers'
import { isStagingWPEnv } from './helpers'

export const pliDomain = 'https://www.publicliabilityinsurance.com.au/'
//Need to determine the api endpoint domain dynamically by current domain name.
//if ccurrent is dev env, then api needed to point to dev.
let domain = ''

// The Dev enc checks the domain for .dev
if(isDevEnv())
{
	let dz = window.location.hostname.match(/\.(.+)$/)
	dz = dz && dz[1] || 'dev'
	domain = `https://pli.${dz}/`
}
else if (isStagingEnv()) {
	// Checks for subdoamin is staging.
	domain = 'https://staging.publicliabilityinsurance.com.au/'
}
else if( isStagingWPEnv() ) 
{
	// Checks for subdoamin is pli. for the staging WP site
    domain = 'https://staging.publicliabilityinsurance.com.au/'
}else{
	// Checks the 
	domain = 'https://portal.publicliabilityinsurance.com.au/'
}

export const apiDomain = domain

// All api related routes
export const apiConfigsUrl = apiDomain+'api/v1/configs'
export const decryptReminderTokenUrl = apiDomain+'api/v1/decrypt-reminder-token'
export const getAllUnavailableOccupationsUrl = apiDomain+'api/v1/occupations/get-unavailable'
export const getCheckOccupationAvailabilityUrl = (occupationId) => {
    return apiDomain+'api/v1/occupations/'+occupationId+'/check-availability'
}

// regular routes which will be used by quote form
export const validateUrl = apiDomain+'form/validate'
export const validateMobileUrl = apiDomain+'form/mobile/validate'
export const pricingUrl = apiDomain+'form/calculate' 
export const checkPostCodeUrl = apiDomain+'form/check-post-code'
export const getPendingOrderUrl = apiDomain+'form/get-pending-order/'
export const checkPendingOrderExistsUrl = apiDomain+'form/check-pending-order-exists/'
export const emailQuoteUrl = apiDomain+'form/email-quote'
export const getOrderUrl = apiDomain+'form/get-order/';
export const underwritersUrl = apiDomain+'form/underwriters'
export const questionsUrl = apiDomain+'form/questions'
export const removeAccidentCovers = apiDomain+'form/accident-covers/order/remove'
export const getAccidentCovers = apiDomain+'form/accident-covers/all'
export const logoUrl = 'https://www.publicliabilityinsurance.com.au/wp-content/uploads/2017/02/PLI_logotransparent.png'
export const fsgPdfUrl = 'https://bluewell.com.au/fsg-privacy-policy/'
export const dutyOfDisclosureUrl = 'https://publicliabilityinsurance.com.au/duty-of-disclosure/'
export const payByTheMonthUrl = domain+'pay-by-the-month'
export const generalAdviceWarning = domain+'general-advice-warning'
export const termsAndConditionsUrl = 'https://publicliabilityinsurance.com.au/terms/'
export const bannerUrl = 'https://www.publicliabilityinsurance.com.au/wp-content/uploads/2018/04/Thailand2018-TermsAndConditions.pdf'
export const accidentCoverPDS = 'https://publicliabilityinsurance.com.au/wp-content/uploads/2024/11/AFA_PA_PDS_v15_Aug_2023_2.pdf'
export const letterOfEngagement = 'https://publicliabilityinsurance.com.au/wp-content/uploads/2023/11/Bluewell-Letter-of-Engagement.pdf'
export const maxHeadCount = 11
export const stripePercentageSurcharge = 0.0175;  // Stripe's % surcharge
export const stripeFixedSurcharge = 0.3; // Stripe's fixed amount surcharge
export const eFundInterestRate = 1.14; // EFund interest rate

export const getStatesUrl = domain + 'info/valid-location-states';

export const amountOptions = {
	5000000: '5M',
	10000000: '10M',
	20000000: '20M'
}

export const mobileAmountOptions = {
	5000000: '5 Million',
	10000000: '10 Million',
	20000000: '20 Million'
};

export const defaultAmountOption = '5000000'

export const deductibleOptions = {
	def: {
		500: '$500',
		1000: '$1000'
	},

	brooklyn: {
		1000: '$1000'
	},

	ensurance: {
		500: '$500',
	}
}

export const getAppointmentLetterUrl = apiDomain+'pdf'
// export const getAppointmentLetterUrl = apiDomain+'api/v1/letters/appointment'